import React, { useState, useEffect } from 'react';

const SupervisoresReporte = (p) => {
    const reportes = p.reportes ?? { datos: [], fechas: [], grupos: [], supervisores: [] };
    const [indexDetalles, setindexDetalles] = useState(-1);
    const [reporteRanchoArea, setreporteRanchoArea] = useState([]);

    useEffect(() => {
        setindexDetalles(-1);
        reportePorRanchoArea();
    }, [p.reportes]);

    const colorAvance = (porcentajeAvance) => {
        if (porcentajeAvance < 50) return '#a91f00';
        if (porcentajeAvance < 80) return '#c36b00';
        if (porcentajeAvance < 90) return '#76a800';
        if (porcentajeAvance > 100) return '#005a70';
        return '#008000';
    }

    const reportePorRanchoArea = () => {
        const repSup = {}
        reportes.datos.forEach(d => {
            if (!repSup[d.asignado_por]) {
                repSup[d.asignado_por] = {};
            }
            const rNombre = d.rancho_nombre ?? "S/N";
            if (!repSup[d.asignado_por][rNombre]) {
                repSup[d.asignado_por][rNombre] = {
                    rancho: rNombre,
                    empleados: {},
                    num_empleados: 0,
                    horas_asignadas: 0,
                    horas_realizadas: 0,
                    areas: {}
                };
            }
            if (!repSup[d.asignado_por][rNombre].empleados[d.asignado_a]) {
                repSup[d.asignado_por][rNombre].empleados[d.asignado_a] = true;
                repSup[d.asignado_por][rNombre].num_empleados += 1;
            }
            if (!repSup[d.asignado_por][rNombre].areas[d.area_nombre]) {
                repSup[d.asignado_por][rNombre].areas[d.area_nombre] = {
                    area: d.area_nombre,
                    horas_asignadas: 0,
                    horas_realizadas: 0,
                    num_empleados: 0,
                    empleados: {}
                };
            }
            if (!repSup[d.asignado_por][rNombre].areas[d.area_nombre].empleados[d.asignado_a]) {
                repSup[d.asignado_por][rNombre].areas[d.area_nombre].empleados[d.asignado_a] = true;
                repSup[d.asignado_por][rNombre].areas[d.area_nombre].num_empleados += 1;
            }
            const tiempo_asignado = d.unidades_asignadas * d.ms_por_unidad / 3600000; // Convertir ms a horas
            const tiempo_realizado = d.unidades_realizadas * d.ms_por_unidad / 3600000; // Convertir ms a horas
            repSup[d.asignado_por][rNombre].areas[d.area_nombre].horas_asignadas += tiempo_asignado;
            repSup[d.asignado_por][rNombre].areas[d.area_nombre].horas_realizadas += tiempo_realizado;
            repSup[d.asignado_por][rNombre].horas_asignadas += tiempo_asignado;
            repSup[d.asignado_por][rNombre].horas_realizadas += tiempo_realizado;
        });

        reportes.supervisores.forEach((sup, i) => {
            const nombre = sup.supervisor_nombre;
            const reporteRenchos = repSup[nombre] ? Object.values(repSup[nombre]).map(rancho => {
                rancho.areas = Object.values(rancho.areas);
                rancho.areas.sort((a, b) => a.area.localeCompare(b.area));
                return rancho;
            }) : [];
            reportes.supervisores[i].ranchos = reporteRenchos;
        })
        setreporteRanchoArea(reportes.supervisores);
    }


    return (
        <div className='supervisores-reporte-container w-100 dosis mt-5' style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 120px)' }}>
            <div className='row justify-content-around w-100 m-0 p-0'>
                <table className='table table-sm table-borderless bw-1300  text-m' style={{ borderCollapse: 'separate', borderSpacing: 0 }}>
                    <thead style={{ position: 'sticky', top: 0, zIndex: 10, backgroundColor: 'white' }}>
                        <tr>
                            <th scope='col'>SUPERVISOR</th>
                            <th scope='col' className='text-end pe-3 nowrap'>EMPLEADOS</th>
                            <th scope='col' className='text-end pe-3 nowrap'>HRS. ASIGNADAS</th>
                            <th scope='col' className='text-end pe-3 nowrap'>HRS. REALIZADAS</th>

                            <th scope='col' className='text-end pe-3 nowrap'>HRS. 1ER TURNO</th>
                            <th scope='col' className='text-end pe-3 nowrap'>HRS. 2DO TURNO</th>
                            <th scope='col' className='text-end pe-3 nowrap'>MONTO BONOS</th>
                            <th scope='col' className='text-end pe-3 nowrap'>MONTO 1ER. TURNO</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            reporteRanchoArea.map((sup, index) => {
                                const tdClass = 'bg-black5';
                                const opacity = indexDetalles === -1 || indexDetalles === index ? 100 : 60;
                                const cumplimiento = +(sup.horas_asignadas === 0 ? 0 : (sup.horas_realizadas / sup.horas_asignadas * 100).toFixed(2));
                                return (<React.Fragment key={index + "superv"}>
                                    <tr>
                                        <td scope='row' className={`bg-transparent text-bold ps-3 ${tdClass}`} style={{ borderRadius: '8px 0 0 0' }}>{sup.supervisor_nombre}</td>
                                        <td className={`text-end pe-3 ${tdClass}`}>{sup.empleados}</td>
                                        <td className={`text-end pe-3 ${tdClass}`}>{sup.horas_asignadas}</td>
                                        <td className={`text-end pe-3 ${tdClass}`}>{sup.horas_realizadas}</td>
                                        <td className={`text-end pe-3 ${tdClass}`}>{sup.horas_primer_turno}</td>
                                        <td className={`text-end pe-3 ${tdClass}`}>{sup.horas_segundo_turno}</td>
                                        <td className={`text-end pe-3 ${tdClass}`}>${sup.bonos.toFixed(2)}</td>
                                        <td className={`text-end pe-3 ${tdClass}`} style={{ borderRadius: '0 8px 0 0' }}>${sup.pago_primer_turno.toFixed(2)}</td>
                                    </tr>

                                    <React.Fragment>
                                        {sup.ranchos.map((rancho, rIndex) => {
                                            const bordeSuperior = rIndex > 0 ? 'border-top' : '';
                                            const cumplimientoRancho = +(rancho.horas_asignadas === 0 ? 0 : (rancho.horas_realizadas / rancho.horas_asignadas * 100).toFixed(2));
                                            return (
                                                <React.Fragment key={rIndex + "rancho rep"}>
                                                    <tr className={`text-s text-bold`}>
                                                        <td scope='row' className={`bg-transparent border-start ${bordeSuperior} text-start`}>{rancho.rancho}</td>
                                                        <td className={`text-end pe-3 bg-transparent ${bordeSuperior}`}>{rancho.num_empleados}</td>
                                                        <td className={`text-end pe-3 bg-transparent ${bordeSuperior}`}>{Math.round(rancho.horas_asignadas * 100) / 100}</td>
                                                        <td className={`text-end pe-3 bg-transparent ${bordeSuperior}`}>{Math.round(rancho.horas_realizadas * 100) / 100}</td>
                                                        <td className={`text-end bg-transparent align-middle`}>
                                                            <div className='bw-150'>
                                                                <span className='bg-white5 round-xxl m-0 p-0 text-s fw-light'>Cump. Rancho: {cumplimientoRancho + '%'}</span>
                                                                <div className={`col-12 round-xxl border p-0 bg-black5`}>
                                                                    <div className='pt-1 round-xxl' style={{ width: Math.min(cumplimientoRancho, 100) + '%', backgroundColor: colorAvance(cumplimientoRancho) }}>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className={`text-end pe-3 bg-transparent `}></td>
                                                        <td className={`text-end pe-3 bg-transparent `}></td>
                                                        <td className={`text-end pe-3 bg-transparent border-end `}></td>
                                                    </tr>
                                                    {rancho.areas.map((area, aIndex) => {
                                                        const lenA = rancho.areas.length;
                                                        const ranchosLen = sup.ranchos.length;
                                                        const padding = ranchosLen !== 1 && aIndex === lenA - 1 ? 'pb-3' : '';
                                                        const bordeInferior = aIndex < lenA - 1 ? 'border-bottom' : '';
                                                        const bordeSuperior = aIndex === 0 ? 'border-top' : '';
                                                        const cumplimientoArea = +(area.horas_asignadas === 0 ? 0 : (area.horas_realizadas / area.horas_asignadas * 100).toFixed(2));
                                                        return (
                                                            <tr key={aIndex + "area rep"} className={`text-s`} style={{ lineHeight: '1' }}>
                                                                <td scope='row' className={`bg-transparent pe-0 border-start text-end ${padding}`}>{area.area}</td>
                                                                <td className={`text-end pe-3 bg-transparent ${padding} ${bordeInferior} ${bordeSuperior}`}>{area.num_empleados}</td>
                                                                <td className={`text-end pe-3 bg-transparent ${padding} ${bordeInferior} ${bordeSuperior}`}>{Math.round(area.horas_asignadas * 100) / 100}</td>
                                                                <td className={`text-end pe-3 bg-transparent ${padding} ${bordeInferior} ${bordeSuperior}`}>{Math.round(area.horas_realizadas * 100) / 100}</td>
                                                                <td className={`text-end pe-3 bg-transparent ${padding}`}>
                                                                    <div className='bw-100'>
                                                                        <span className='bg-white5 round-xxl m-0 p-0 text-xs fw-light'>Cump. Área: {cumplimientoArea + '%'}</span>
                                                                        <div className={`col-12 round-xxl border p-0 bg-black5 opacity-60`}>
                                                                            <div className='pt-1 round-xxl' style={{ width: Math.min(cumplimientoArea, 100) + '%', backgroundColor: colorAvance(cumplimientoArea) }}>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td className={`text-end pe-3 bg-transparent ${padding}`}></td>
                                                                <td className={`text-end pe-3 bg-transparent ${padding}`}></td>
                                                                <td className={`text-end pe-3 bg-transparent border-end ${padding}`}></td>
                                                            </tr>
                                                        )
                                                    })}
                                                </React.Fragment>)
                                        })}

                                        <tr >
                                            <td colSpan={8} className={`pb-0 ps-3 pe-5 border-start border-end`}>
                                                <div className="bw p-0 text-s" style={{ '--bw': '600px' }}>
                                                    <span className='text-m round-xxl m-0 p-0 ps-3 pe-3'>Cumplimiento general: {cumplimiento + '%'}</span>
                                                    <div className={`col-100 round-xxl border p-0 bg-black5`}>
                                                        <div className='p-1 round-xxl' style={{ width: Math.min(cumplimiento, 100) + '%', backgroundColor: colorAvance(cumplimiento) }}>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colSpan={8} className={`border-bottom border-start border-end  p-2`} style={{ borderRadius: '0 0 8px 8px' }}></td>
                                        </tr>
                                        <tr>
                                            <td colSpan={8} className={`pb-3`}></td>
                                        </tr>
                                    </React.Fragment>

                                </React.Fragment>
                                )
                            })}
                    </tbody>
                </table>
                <div className='col-lg-12 mt-5 mb-5 p-5'></div>
            </div>
        </div>

    )


}

export default SupervisoresReporte;